import React, { type SVGProps } from 'react'

const ErrorIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    {...props}
  >
    <path
      d="M24.8 49.6C38.4981 49.6 49.6 38.4981 49.6 24.8C49.6 11.1019 38.4981 0 24.8 0C11.1019 0 0 11.1019 0 24.8C0 38.4981 11.1019 49.6 24.8 49.6ZM24.8 13.175C26.0884 13.175 27.125 14.2116 27.125 15.5V26.35C27.125 27.6384 26.0884 28.675 24.8 28.675C23.5116 28.675 22.475 27.6384 22.475 26.35V15.5C22.475 14.2116 23.5116 13.175 24.8 13.175ZM22.2134 34.1C22.1553 33.1409 22.63 32.2303 23.4534 31.7266C24.2769 31.2325 25.3134 31.2325 26.1369 31.7266C26.9603 32.2303 27.435 33.1409 27.3769 34.1C27.435 35.0591 26.9603 35.9697 26.1369 36.4734C25.3134 36.9675 24.2769 36.9675 23.4534 36.4734C22.63 35.9697 22.1553 35.0591 22.2134 34.1Z"
      fill="currentColor"
    />
  </svg>
)

export default ErrorIcon
